function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { Container, CssContainer } from "../../components/container";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import ServiceFactory from "../../service";
import Auth from "../../functions/authenticate";
import ManageDataTabs from "../../components/manage-data-tabs";
import { num } from "../sales/territory-common";
import { Button } from "@progress/kendo-react-buttons";

/*
 * Manage Data — feed pipelines (DATA_FEED_SERVICE.md §3 + mockup
 * manage-data-feeds.html; backend = /v1/data-feeds on AnalyticsService,
 * live on the new DataFeedService rail for all five tenants).
 *
 * Signature element: the PIPELINE RAIL per feed — Source → Mode →
 * Schedule → Last run → Run now — so feed health is scannable per entity.
 * Plus: Validate-feed preflight (fetch URL, parse header, show columns
 * BEFORE save), run history, schedule CRUD. Settings JSON carries
 * credentials — password fields are masked and never echoed back
 * (edit leaves password blank = keep current).
 */

function svc(api) {
  const Service = ServiceFactory.getType(`/data-feeds${api}`, "product"); // /v1 root
  return new Service();
}
async function safe(promise, fallback) {
  try {
    return (await promise) || fallback;
  } catch (e) {
    return fallback;
  }
}
function parseSettings(row) {
  try {
    return JSON.parse(row.settings || "{}");
  } catch (e) {
    return {};
  }
}
function hostOf(url) {
  try {
    return new URL(url).hostname;
  } catch (e) {
    return url || "—";
  }
}
function fmtWhen(d) {
  if (!d) return "—";
  const x = new Date(d);
  if (isNaN(x.getTime())) return "—";
  return `${x.getMonth() + 1}/${x.getDate()} ${String(x.getHours()).padStart(2, "0")}:${String(x.getMinutes()).padStart(2, "0")}`;
}
const FREQUENCIES = ["Daily", "Hourly", "Weekly"];
const EMPTY_FORM = {
  id: null,
  provider: "",
  url: "",
  username: "",
  password: "",
  mode: "",
  frequency: "Daily",
  hour: 4,
  timezone: "UTC",
  status: "Active"
};

// §255: tenant-facing provider label from the descriptor (submit/store `name`).
function providerLabel(providers, name) {
  const p = (providers || []).find(x => x.name === name);
  return p && p.displayName || name;
}
class ManageDataViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "reload", () => {
      this.setState({
        schedules: null,
        error: false
      }, () => this.load());
    });
    // ------------------------------------------------------------- actions
    _defineProperty(this, "startAdd", () => this.setState({
      form: {
        ...EMPTY_FORM
      },
      validation: null
    }));
    _defineProperty(this, "startEdit", row => {
      const settings = parseSettings(row);
      this.setState({
        form: {
          id: row.id,
          provider: row.provider,
          url: settings.Url || settings.url || "",
          username: settings.Username || "",
          password: "",
          // never echoed — blank keeps current
          mode: row.mode,
          frequency: row.frequency,
          hour: row.hour,
          timezone: row.timezone || "UTC",
          status: row.status,
          referenceId: settings.ReferenceId || "",
          _hadPassword: !!settings.Password
        },
        validation: null
      });
    });
    _defineProperty(this, "field", k => e => this.setState({
      form: {
        ...this.state.form,
        [k]: e.target.value
      }
    }));
    _defineProperty(this, "save", async () => {
      const f = this.state.form;
      if (!f || this.state.saving || !f.provider || !f.url) return;
      // Start from the row's FULL previous settings — providers carry keys
      // this form doesn't manage (e.g. the CustomerFeed row's Hour); a
      // rebuilt-from-scratch object silently dropped them on edit.
      const row = (this.state.schedules || []).find(s => s.id === f.id);
      const prev = row ? parseSettings(row) : {};
      const settings = {
        ...prev,
        Url: f.url
      };
      if (f.username) settings.Username = f.username;
      if (f.password) settings.Password = f.password;
      // (absent password + _hadPassword → prev.Password already carried over)
      if (f.referenceId) settings.ReferenceId = f.referenceId;else delete settings.ReferenceId;
      this.setState({
        saving: true
      });
      try {
        await svc("/schedules").postAsync({
          id: f.id || undefined,
          provider: f.provider,
          settings: JSON.stringify(settings),
          mode: f.mode,
          frequency: f.frequency,
          hour: Number(f.hour) || 0,
          timezone: f.timezone || "UTC",
          status: f.status
        });
        this.setState({
          saving: false,
          form: null
        });
        this.reload();
      } catch (e) {
        this.setState({
          saving: false,
          notice: "Save failed — check the values and your permissions."
        });
      }
    });
    _defineProperty(this, "validate", async () => {
      const f = this.state.form;
      if (!f || !f.url || this.state.validating) return;
      this.setState({
        validating: true,
        validation: null
      });
      try {
        const res = await svc("/validate").postAsync({
          url: f.url,
          username: f.username || null,
          password: f.password || null,
          provider: f.provider || null
        });
        this.setState({
          validating: false,
          validation: res
        });
      } catch (e) {
        this.setState({
          validating: false,
          validation: {
            valid: false,
            error: "Validation call failed."
          }
        });
      }
    });
    _defineProperty(this, "runNow", row => async () => {
      if (this.state.running[row.id]) return;
      this.setState({
        running: {
          ...this.state.running,
          [row.id]: true
        },
        notice: null
      });
      try {
        await svc(`/schedules/${row.id}/run`).postAsync({});
        this.setState({
          notice: `${providerLabel(this.state.providers, row.provider)} run queued — it appears in Run History as it starts.`
        });
        setTimeout(() => {
          if (this._alive) this.load();
        }, 4000);
      } catch (e) {
        this.setState({
          notice: "Run-now failed."
        });
      }
      this.setState({
        running: {
          ...this.state.running,
          [row.id]: false
        }
      });
    });
    _defineProperty(this, "remove", async row => {
      try {
        await svc("/schedules").deleteAsync(row.id);
        this.setState({
          confirmDelete: null
        });
        this.reload();
      } catch (e) {
        this.setState({
          notice: "Delete failed.",
          confirmDelete: null
        });
      }
    });
    this.state = {
      providers: null,
      schedules: null,
      runs: [],
      error: false,
      form: null,
      saving: false,
      validating: false,
      validation: null,
      running: {},
      notice: null,
      confirmDelete: null,
      audiences: null // lazy — loaded when an Audience feed form opens
    };
    this._alive = true;
  }
  async componentDidMount() {
    if (Auth.isAuthenticated() || (await Auth.attachOrSignIn())) this.load();
  }
  componentWillUnmount() {
    this._alive = false;
  }
  async load() {
    try {
      const [providers, schedules, runs] = await Promise.all([svc("/providers").getAsync(), svc("/schedules").getAsync(), safe(svc("/runs?top=30").getAsync(), [])]);
      if (!this._alive) return;
      this.setState({
        providers: providers || [],
        schedules: schedules || [],
        runs: runs || []
      });
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }
  // Target-audience options for the Audience provider (the spec's
  // picker-not-free-text rule — ReferenceId typos are how R&S got 655
  // duplicate audiences). System audiences (All Contacts, Customers) are
  // NOT import targets; the current value stays selectable so editing an
  // existing schedule (e.g. R&S's legacy Customers dual-run) can't lose it.
  loadAudiences() {
    if (this.state.audiences !== null) return;
    this.setState({
      audiences: []
    });
    const Service = ServiceFactory.getType("/audience?$top=200", "audience");
    new Service().getAsync().then(r => {
      if (this._alive) this.setState({
        audiences: r && r.items || []
      });
    }).catch(() => {
      if (this._alive) this.setState({
        audiences: []
      });
    });
  }
  lastRunFor(scheduleId) {
    return this.state.runs.find(r => r.scheduleId === scheduleId) || null;
  }
  // ------------------------------------------------------------- render

  renderRunBadge(run) {
    if (!run) return /*#__PURE__*/React.createElement("span", {
      className: "df-badge"
    }, "never run");
    if (run.success === null && !run.finishedDate) return /*#__PURE__*/React.createElement("span", {
      className: "df-badge running"
    }, "running\u2026");
    if (run.success) {
      return /*#__PURE__*/React.createElement("span", {
        className: "df-badge ok",
        title: run.message || ""
      }, "\u2713 ", fmtWhen(run.finishedDate || run.startedDate), run.rowsUpserted != null ? ` · ${num(run.rowsUpserted)} rows` : "");
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "df-badge fail",
      title: run.message || ""
    }, "\u2715 ", fmtWhen(run.finishedDate || run.startedDate), " \u2014 failed");
  }
  renderForm() {
    const {
      form: f,
      providers,
      saving,
      validating,
      validation
    } = this.state;
    if (!f) return null;
    const prov = (providers || []).find(p => p.name === f.provider);
    const modes = prov && prov.modes || [];
    const inp = {
      padding: "6px 8px",
      border: "1px solid var(--plk-border)",
      borderRadius: "4px",
      fontSize: "13px",
      width: "100%"
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "cd2-card",
      style: {
        marginTop: "14px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "cd2-cardhead"
    }, /*#__PURE__*/React.createElement("h2", null, f.id ? "Edit feed" : "New feed")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "10px",
        maxWidth: "980px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Provider", /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: f.provider,
      onChange: e => {
        const p = (providers || []).find(x => x.name === e.target.value);
        this.setState({
          form: {
            ...f,
            provider: e.target.value,
            mode: p && p.modes[0] || ""
          }
        });
      }
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "\u2014 select \u2014"), (providers || []).map(p => /*#__PURE__*/React.createElement("option", {
      key: p.name,
      value: p.name
    }, p.displayName || p.name)))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px",
        gridColumn: "span 2"
      }
    }, "Feed URL", /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: f.url,
      onChange: this.field("url"),
      placeholder: "https://\u2026/feed.csv"
    })), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Username (optional)", /*#__PURE__*/React.createElement("input", {
      style: inp,
      value: f.username,
      onChange: this.field("username"),
      autoComplete: "off"
    })), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Password (optional)", /*#__PURE__*/React.createElement("input", {
      style: inp,
      type: "password",
      value: f.password,
      onChange: this.field("password"),
      placeholder: f._hadPassword ? "•••••• (unchanged)" : "",
      autoComplete: "new-password"
    })), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Mode", /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: f.mode,
      onChange: this.field("mode")
    }, modes.map(m => /*#__PURE__*/React.createElement("option", {
      key: m,
      value: m
    }, m)))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Frequency", /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: f.frequency,
      onChange: this.field("frequency")
    }, FREQUENCIES.map(x => /*#__PURE__*/React.createElement("option", {
      key: x,
      value: x
    }, x)))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Hour (0\u201323)", /*#__PURE__*/React.createElement("input", {
      style: inp,
      type: "number",
      min: "0",
      max: "23",
      value: f.hour,
      onChange: this.field("hour")
    })), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Timezone", /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: f.timezone,
      onChange: this.field("timezone")
    }, ["UTC", "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles"].map(z => /*#__PURE__*/React.createElement("option", {
      key: z,
      value: z
    }, z)))), /*#__PURE__*/React.createElement("label", {
      style: {
        fontSize: "12px"
      }
    }, "Status", /*#__PURE__*/React.createElement("select", {
      style: inp,
      value: f.status,
      onChange: this.field("status")
    }, /*#__PURE__*/React.createElement("option", {
      value: "Active"
    }, "Active"), /*#__PURE__*/React.createElement("option", {
      value: "Inactive"
    }, "Inactive"))), f.provider === "Audience" && (() => {
      this.loadAudiences();
      const SYSTEM = ["all contacts", "customers"];
      const opts = (this.state.audiences || []).filter(a => !SYSTEM.includes(String(a.name || "").toLowerCase()) || a.name === f.referenceId).map(a => a.name);
      if (f.referenceId && !opts.includes(f.referenceId)) opts.unshift(f.referenceId);
      return /*#__PURE__*/React.createElement("label", {
        style: {
          fontSize: "12px"
        }
      }, "Target audience", /*#__PURE__*/React.createElement("select", {
        style: inp,
        value: f.referenceId || "",
        onChange: this.field("referenceId")
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, "\u2014 select an audience \u2014"), opts.map(n => /*#__PURE__*/React.createElement("option", {
        key: n,
        value: n
      }, n))), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "11px",
          color: "var(--plk-text-dim)"
        }
      }, "Imported members join this audience. System audiences aren't import targets."));
    })()), validation && /*#__PURE__*/React.createElement("div", {
      className: "territory-hint",
      style: {
        marginTop: "12px",
        padding: "10px 12px",
        borderRadius: "6px",
        background: validation.valid ? "var(--plk-success-soft)" : "var(--plk-danger-soft)",
        color: validation.valid ? "var(--plk-success)" : "var(--plk-danger)"
      }
    }, validation.valid ? /*#__PURE__*/React.createElement("span", null, "Feed looks good \u2014 ", num((validation.columns || []).length), " columns", validation.columns ? `: ${validation.columns.slice(0, 10).join(", ")}${validation.columns.length > 10 ? "…" : ""}` : "") : /*#__PURE__*/React.createElement("span", null, validation.error || "The feed could not be read.")), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "10px",
        marginTop: "14px"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: validating || !f.url,
      onClick: this.validate
    }, validating ? "Validating…" : "Validate feed"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: saving || !f.provider || !f.url,
      onClick: this.save
    }, saving ? "Saving…" : "Save"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        form: null,
        validation: null
      })
    }, "Cancel")));
  }
  render() {
    const {
      providers,
      schedules,
      runs,
      error,
      notice,
      running,
      confirmDelete
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (schedules === null || providers === null) return /*#__PURE__*/React.createElement(Loader, null);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view df-view"
    }, /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Manage Data")), /*#__PURE__*/React.createElement(ManageDataTabs, {
      active: "/Data"
    }), notice && /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        background: "var(--plk-info-soft)",
        border: "1px solid var(--plk-info)",
        borderRadius: "6px",
        padding: "8px 12px"
      }
    }, notice, " ", /*#__PURE__*/React.createElement("a", {
      onClick: () => this.setState({
        notice: null
      }),
      style: {
        cursor: "pointer",
        marginLeft: "8px"
      }
    }, "dismiss"))), /*#__PURE__*/React.createElement(Container, {
      title: "Feeds",
      css: "margin-squeeze"
    }, !schedules.length && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "No feeds configured yet."), schedules.map(row => {
      const settings = parseSettings(row);
      const run = this.lastRunFor(row.id);
      return /*#__PURE__*/React.createElement("div", {
        key: row.id,
        className: "df-rail"
      }, /*#__PURE__*/React.createElement("div", {
        className: "df-cell prov"
      }, /*#__PURE__*/React.createElement("div", {
        className: "p"
      }, providerLabel(this.state.providers, row.provider)), /*#__PURE__*/React.createElement("div", {
        className: "s " + (row.status === "Active" ? "on" : "off")
      }, row.status)), /*#__PURE__*/React.createElement("div", {
        className: "df-cell"
      }, /*#__PURE__*/React.createElement("div", {
        className: "k"
      }, "Source"), /*#__PURE__*/React.createElement("div", {
        className: "v",
        title: settings.Url || ""
      }, hostOf(settings.Url))), /*#__PURE__*/React.createElement("div", {
        className: "df-cell"
      }, /*#__PURE__*/React.createElement("div", {
        className: "k"
      }, "Mode"), /*#__PURE__*/React.createElement("div", {
        className: "v"
      }, row.mode)), /*#__PURE__*/React.createElement("div", {
        className: "df-cell"
      }, /*#__PURE__*/React.createElement("div", {
        className: "k"
      }, "Schedule"), /*#__PURE__*/React.createElement("div", {
        className: "v"
      }, row.frequency, " \xB7 ", String(row.hour).padStart(2, "0"), ":00 ", row.timezone || "UTC")), /*#__PURE__*/React.createElement("div", {
        className: "df-cell grow"
      }, /*#__PURE__*/React.createElement("div", {
        className: "k"
      }, "Last run"), /*#__PURE__*/React.createElement("div", {
        className: "v"
      }, this.renderRunBadge(run))), /*#__PURE__*/React.createElement("div", {
        className: "df-actions"
      }, /*#__PURE__*/React.createElement(Button, {
        size: "small",
        disabled: !!running[row.id],
        onClick: this.runNow(row)
      }, running[row.id] ? "Queuing…" : "Run now"), /*#__PURE__*/React.createElement(Button, {
        size: "small",
        onClick: () => this.startEdit(row)
      }, "Edit"), confirmDelete === row.id ? /*#__PURE__*/React.createElement(Button, {
        size: "small",
        themeColor: "error",
        onClick: () => this.remove(row)
      }, "Confirm delete") : /*#__PURE__*/React.createElement(Button, {
        size: "small",
        onClick: () => this.setState({
          confirmDelete: row.id
        })
      }, "Delete")));
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: "12px"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.startAdd
    }, "Add feed")), this.renderForm()), /*#__PURE__*/React.createElement(Container, {
      title: "Run History",
      css: "margin-squeeze"
    }, !runs.length ? /*#__PURE__*/React.createElement("p", {
      className: "territory-hint"
    }, "No runs recorded yet.") : /*#__PURE__*/React.createElement("table", {
      className: "territory-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Started"), /*#__PURE__*/React.createElement("th", null, "Provider"), /*#__PURE__*/React.createElement("th", null, "Mode"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", {
      className: "r"
    }, "Read"), /*#__PURE__*/React.createElement("th", {
      className: "r"
    }, "Upserted"), /*#__PURE__*/React.createElement("th", {
      className: "r"
    }, "Deleted"), /*#__PURE__*/React.createElement("th", null, "Message"))), /*#__PURE__*/React.createElement("tbody", null, runs.map(r => /*#__PURE__*/React.createElement("tr", {
      key: r.id
    }, /*#__PURE__*/React.createElement("td", null, fmtWhen(r.startedDate)), /*#__PURE__*/React.createElement("td", null, providerLabel(this.state.providers, r.provider)), /*#__PURE__*/React.createElement("td", null, r.mode), /*#__PURE__*/React.createElement("td", null, r.success === null && !r.finishedDate ? /*#__PURE__*/React.createElement("span", {
      className: "df-badge running"
    }, "running\u2026") : r.success ? /*#__PURE__*/React.createElement("span", {
      className: "df-badge ok"
    }, "\u2713 ok") : /*#__PURE__*/React.createElement("span", {
      className: "df-badge fail"
    }, "\u2715 failed")), /*#__PURE__*/React.createElement("td", {
      className: "r"
    }, r.rowsRead == null ? "—" : num(r.rowsRead)), /*#__PURE__*/React.createElement("td", {
      className: "r"
    }, r.rowsUpserted == null ? "—" : num(r.rowsUpserted)), /*#__PURE__*/React.createElement("td", {
      className: "r"
    }, r.rowsDeleted == null ? "—" : num(r.rowsDeleted)), /*#__PURE__*/React.createElement("td", {
      style: {
        maxWidth: "320px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      title: r.message || ""
    }, r.message || "—")))))));
  }
}
export default withRouter(ManageDataViewComponent);